
import { authHeader } from '../../_helpers';
import axios from 'axios';

export const relationGroupsService = {
    getRelationGroups,
    addRelationGroup,
    editRelationGroup,
    editRelation,
    deleteRelation,
    userRelationGroupHandler
};

axios.defaults.headers.common = authHeader();


function getRelationGroups() {
    let token = localStorage.getItem('access_token')

    return axios.get(`/masters/relation/group/list/create/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function addRelationGroup(data) {

    return axios.post('/masters/relation/group/list/create/', data)
        .then(response => {
            return response;
        })
}

function editRelationGroup(id, data) {

    return axios.put('/masters/relation/group/edit/' + id + '/', data)
        .then(response => {
            return response;
        }
        )
}

function editRelation(id, data) {
    return axios.post('/masters/relation/group/edit/relation/' + id + '/', data)
        .then(response => {
            return response;
        })
}

function deleteRelation(id) {
    return axios.get('/masters/relation/group/delete/' + id + '/')
        .then(response => {
            return response;
        })
}

function userRelationGroupHandler(data) {
    return axios.post('/assessments/fetch/user/relation/groups/', data)
        .then(response => {
            return response;
        })
}



// WEBPACK FOOTER //
// ./src/_services/relationGroups/relationGroups.service.js